import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function Stats() {
  const {
    ref,
    isVisible
  } = useFadeIn();
  const stats = [{
    number: '1.000+',
    label: 'Pacientes Satisfechos'
  }, {
    number: '5+',
    label: 'Años de Experiencia'
  }, {
    number: '571',
    label: 'Casos Documentados'
  }, {
    number: '9.986',
    label: 'Seguidores Verificados'
  }];
  return <section className="bg-secondary relative py-16 border-y border-border overflow-hidden" data-id="element-300">
      {/* Background Image Hint */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-301">
        <img src="https://cdn.magicpatterns.com/uploads/6kYu18YAGqGkEVVUypsrB7/10.jpg" alt="" className="w-full h-full object-cover" data-id="element-302" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-303">
        <div ref={ref} className={`grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-0 divide-y md:divide-y-0 md:divide-x divide-gold/20 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-304">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center justify-center text-center py-6 md:py-0 px-4" data-id="element-305">
              <span className="font-serif text-4xl md:text-5xl text-gold mb-2" data-id="element-306">
                {stat.number}
              </span>
              <span className="text-white text-xs md:text-sm uppercase tracking-wider font-medium" data-id="element-307">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}